var _style, _path, _path2, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBugReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    style: {
      enableBackground: "new 0 0 160 160"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:5;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Corps",
    className: "st0",
    d: "M105.9,88.3c0,26.9-11.5,48.6-25.6,48.6s-25.6-21.8-25.6-48.6S57,64.5,80.4,64.5 C102.6,64.5,105.9,61.5,105.9,88.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "T\\xEAte",
    className: "st1",
    d: "M64.8,54.5c6.1-0.1,18.1-0.2,30.4-0.2c2.4,0,4.2-2.2,3.6-4.5c-2-8.6-7.7-26.1-20.3-25.1 c-12.6,1-16.4,17.6-17.5,25.7C60.8,52.5,62.6,54.5,64.8,54.5z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "Patte_1_droite",
    className: "st2",
    points: "106.7,76.9 128.1,69.9 126,57.4 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "Patte_1_gauche",
    className: "st2",
    points: "53.1,76.9 31.7,69.9 34,59.3 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    id: "Patte_3_droite",
    className: "st2",
    points: "103.5,111.8 124.1,120.9 121.8,129.7 "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    id: "Patte_2_droite",
    className: "st2",
    points: "108.2,95.5 130.5,92.8 133,101.3 "
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    id: "Patte_3_gauche",
    className: "st2",
    points: "57.1,111.8 36.5,120.9 38.9,129.7 "
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    id: "Patte_2_gauche",
    className: "st2",
    points: "52.5,95.5 30.1,92.8 27.6,101.3 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Antenne_droite",
    className: "st2",
    x1: 88.4,
    y1: 27.3,
    x2: 93.8,
    y2: 22.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Antenne_gauche",
    className: "st2",
    x1: 69.3,
    y1: 27.3,
    x2: 63.8,
    y2: 22.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBugReport);
export default __webpack_public_path__ + "static/media/bug_report.992daf33275c86e226d1ffa3b6b8a19e.svg";
export { ForwardRef as ReactComponent };